"use strict";
// T-score helper. Converts theta-hat to a clinical T-score with optional
// section-specific clipping.
//
//   T = 50 + 10 × theta_hat        (PROMIS canonical, unclipped)
//   T = clip([1, 99], 50 + 10·θ̂)   (Promin / SHAW-CAT, the "PROMIN" profile)
//
// Two profile presets cover the cases we care about today. Custom clip
// bounds available via the `clip` option.
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeTScore = void 0;
/**
 * @typedef {'PROMIS' | 'PROMIN' | 'none'} TScoreProfile
 */
/**
 * @param {number} theta
 * @param {TScoreProfile | { profile?: TScoreProfile, clip?: [number, number] }} [opts]
 * @returns {number}
 */
function computeTScore(theta, opts = 'PROMIS') {
    var _a;
    if (!Number.isFinite(theta))
        return NaN;
    const options = typeof opts === 'string' ? { profile: opts } : opts || {};
    const profile = (_a = options.profile) !== null && _a !== void 0 ? _a : 'PROMIS';
    const raw = 50 + 10 * theta;
    let clip;
    if (options.clip) {
        clip = options.clip;
    }
    else if (profile === 'PROMIN') {
        clip = [1, 99];
    }
    else {
        clip = null;
    }
    if (clip == null)
        return raw;
    return Math.max(clip[0], Math.min(clip[1], raw));
}
exports.computeTScore = computeTScore;
//# sourceMappingURL=tScore.js.map